import React from 'react';
import PropTypes from 'prop-types';
import styles from './data-cube.module.scss';
import classnames from 'classnames';

const DataCube = ({ label, value, color, onClick, text, type }) => {
  const componentClassNames = classnames({
    [styles.dataCube]: true,
    [styles.dataCubeFullHeight]: text,
    [styles.dataCubeNoMargin]: !type,
    [styles.dataCubeTop]: type === 'top',
    [styles.dataCubeBottom]: type === 'bottom',
  });

  return (
    <div className={componentClassNames} onClick={onClick}>
      <div className={styles.dataCubeUpper}>
        {type !== 'bottom' ? (
          <div className={styles.dataCubeHeading}>{label}</div>
        ) : null}

        <div
          style={{
            color,
          }}
          className={styles.dataCubeValue}
        >
          {value}
        </div>
        {text ? <div className={styles.dataCubeText}>{text}</div> : null}
      </div>
      <button
        type="button"
        style={{
          background: color,
          display: type === 'top' ? 'none' : 'block',
        }}
        className={styles.dataCubeButton}
        onClick={onClick}
      >
        <svg
          className={styles.dataCubeChevron}
          fill={'white'}
          width="20"
          height="18"
          viewBox="0 0 1792 1792"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: 20, height: 18 }}
        >
          <path d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z" />
        </svg>
      </button>
    </div>
  );
};

DataCube.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  type: PropTypes.string,
};

export default DataCube;



// WEBPACK FOOTER //
// ./src/components/data-cube/data-cube.js